import StormIntroGame from './StormIntroGame';
import Storm from './Storm';
import StormOutro from './StormOutro';
import StormIntro1 from './StormIntro-1';
import StormIntro2 from './StormIntro-2';
import StormIntro3 from './StormIntro-3';

export default [StormIntro1, StormIntro2, StormIntro3, StormIntroGame, Storm, StormOutro];
